var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.346,
    height: 22.125,
    viewBox: "0 0 15.346 22.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000!important;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.b{fill:#fff;}.c,.d{stroke:none;}.d{fill:#009b96;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.169 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.427 9.709)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 6.729
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 6.729,
    transform: "translate(4.154)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 1.625)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    className: "c",
    d: "M15,5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    className: "d",
    d: "M 0 5 L 15 5 L 0 5 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13.846,
    height: 3.692,
    transform: "translate(0.581 2.162)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 11.538,
    height: 14.769,
    transform: "translate(1.735 5.855)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.154,
    height: 2.163,
    transform: "translate(5.427)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.116949b06878c404b456f38ec9280768.svg";
export { ForwardRef as ReactComponent };